import { Component, input, output } from "@angular/core";
import dxTextBox from "devextreme/ui/text_box";

@Component({
  selector: "pms-page-datagrid-toolbar-text",
  template: "",
  standalone: false
})
export class PageDatagridToolbarTextComponent {
  protected readonly component = "dxTextBox";

  placeholder = input.required<string>();

  classList = input<string>("");

  hidden = input<boolean>(false);

  disabled = input<boolean>(false);

  emitTextComponentRef = output<dxTextBox>();

  onValueChanged = output<any>();
}
